import { KonvaEventObject } from "konva/lib/Node";
import { Pos2d } from "../types";

export abstract class TouchableItem {
  private previousTouchPos: Pos2d;
  private previousTouchMovePos: Pos2d | null = null;

  constructor() {
    this.previousTouchPos = { x: 0, y: 0 };
  }

  private isPos2dEquals(pos1: Pos2d, pos2: Pos2d, tolerance = 1e-3) {
    return (
      Math.abs(pos1.x - pos2.x) <= tolerance &&
      Math.abs(pos1.y - pos2.y) <= tolerance
    );
  }

  onTouchStart(e: KonvaEventObject<TouchEvent>) {
    const pos = e.target.getStage()?.getPointerPosition() || {
      x: 0,
      y: 0,
    };
    this.previousTouchPos = pos;
    this.previousTouchMovePos = pos;
  }
  onTouchEnd(e: KonvaEventObject<TouchEvent>, clickHandler: () => void) {
    const endPos = e.target.getStage()?.getPointerPosition() || {
      x: 0,
      y: 0,
    };

    if (this.isPos2dEquals(endPos, this.previousTouchPos)) {
      clickHandler();
    }

    this.previousTouchMovePos = null;
  }

  onTouchMove(e: KonvaEventObject<TouchEvent>, isScrolling: boolean) {
    if (isScrolling) {
      const newPos = e.target.getStage()?.getPointerPosition() || {
        x: 0,
        y: 0,
      };
      if (!!this.previousTouchMovePos) {
        const dx = newPos.x - this.previousTouchMovePos.x;
        const dy = newPos.y - this.previousTouchMovePos.y;
        const canvaContainer = document.getElementById("canva-container");
        if (!!canvaContainer) {
          canvaContainer.scrollLeft -= dx;
          canvaContainer.scrollTop -= dy;
        }
      }

      this.previousTouchMovePos = newPos;
    }
  }
}
